import { CarrotCardCostSharePreAuthContext } from "#/components/carrot-card-cost-share/state/CarrotCardCostSharePreAuthContext"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { BackIcon, Box, Button, Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import React, { useContext } from "react"
import { FormattedMessage } from "react-intl"

export function WarningStep({
  title,
  primaryDescription,
  secondaryDescription,
  tertiaryDescription
}: {
  title: string
  primaryDescription: string | React.ReactNode
  secondaryDescription?: string | React.ReactNode
  tertiaryDescription?: string | React.ReactNode
}): JSX.Element {
  const { send, back } = useStateMachine()
  const { dispatchFormState } = useContext(CarrotCardCostSharePreAuthContext)
  const theme = useTheme()

  function onClickClose(): void {
    dispatchFormState({ type: "RESET_STATE" })
    send("")
  }

  return (
    <>
      <Box sx={(theme) => ({ display: "flex", justifyContent: "center", marginBlockEnd: theme.tokens.spacing.md })}>
        <Box
          component="img"
          src="/images/exclamation-mark-sign.png"
          srcSet="/images/exclamation-mark-sign-2x.png"
          alt=""
          sx={{ blockSize: "250px", inlineSize: "250px" }}
        />
      </Box>

      <Typography variant="h3" sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.xs })}>
        {title}
      </Typography>

      <Stack spacing={theme.spacing(theme.tokens.spacing.md)}>
        <Typography>{primaryDescription}</Typography>
        <Typography>{secondaryDescription}</Typography>
        <Typography>{tertiaryDescription}</Typography>
      </Stack>

      <Box
        sx={(theme) => ({
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBlockStart: theme.tokens.spacing.md
        })}
      >
        <Button variant="text" color="secondary" onClick={back} startIcon={<BackIcon />}>
          <FormattedMessage defaultMessage="Back" />
        </Button>
        <Button onClick={onClickClose}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </Box>
    </>
  )
}
